import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { basePath } from "./Config";

const LoginRoutes = ({ component: Component, roles, ...rest }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const user = localStorage.getItem("user");

    if (user) {
      navigate(basePath);
    }
  }, [navigate]);

  return <Component />;
};

export default LoginRoutes;
